import React, { useState, useEffect, useContext } from "react";
import { getFirestore, updateDoc } from "firebase/firestore";
import { collection, query, where, getDocs } from "firebase/firestore";
import { RequestModalContext } from "../App";

const INSTAGRAM_URL = "https://instagram.com/titledworks"; // Replace with your actual handle
const ALERT_KEY = "titledworks_alert_toggle";
const firestore = getFirestore();

async function getAlertPreference(userEmail) {
  try {
    const usersRef = collection(firestore, "users");
    const q = query(usersRef, where("email", "==", userEmail));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const userDoc = querySnapshot.docs[0];
      const userData = userDoc.data();
      // Return the actual value from Firebase, or null if not set
      return userData.alerts !== undefined ? userData.alerts : null;
    }
  } catch (error) {
    console.error("Error fetching alert preference:", error);
  }
  return null;
}

async function updateAlertPreference(userEmail, alertOn) {
  // Find the user's document by email (assuming email is unique)
  // If you have the document ID, use that instead for efficiency!
  const usersRef = collection(firestore, "users");
  const q = query(usersRef, where("email", "==", userEmail));
  const querySnapshot = await getDocs(q);
  if (!querySnapshot.empty) {
    const userDoc = querySnapshot.docs[0];
    await updateDoc(userDoc.ref, { alerts: alertOn });
  }
}

const Footer = ({ user }) => {
  const { setShowRequestModal } = useContext(RequestModalContext);
  const [alertOn, setAlertOn] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(ALERT_KEY)) || false;
    } catch {
      return false;
    }
  });

  // Fetch alert preference from Firebase on mount
  useEffect(() => {
    if (user?.email) {
      getAlertPreference(user.email).then((firebaseValue) => {
        // Only update if Firebase has a value (not null)
        if (firebaseValue !== null) {
          setAlertOn(firebaseValue);
        }
      });
    }
  }, [user?.email]);

  useEffect(() => {
    localStorage.setItem(ALERT_KEY, JSON.stringify(alertOn));
  }, [alertOn]);

  return (
    <footer className="border-t border-gray-200 bg-white py-12 md:py-24 mt-12">
      <div className="max-w-8xl mx-auto px-4 lg:px-6 xl:px-8 flex flex-col md:flex-row justify-between items-center gap-8">
        {/* Alert Toggle */}
        <div className="w-full md:w-2/3 text-left">
          <div className="flex items-center gap-4 max-w-md pb-2">
            <button
              type="button"
              aria-pressed={alertOn}
              onClick={async () => {
                setAlertOn((v) => {
                  const newValue = !v;
                  updateAlertPreference(user.email, newValue);
                  return newValue;
                });
              }}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 ${alertOn ? "bg-black" : "bg-gray-200"}`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${alertOn ? "translate-x-6" : "translate-x-1"}`}
              />
            </button>
            <span className="text-base">Alert me with new items</span>
          </div>
          {alertOn && (
            <div className="text-green-700 mt-4 text-sm font-medium">
              You'll be alerted when new items are added!
            </div>
          )}
          <div className="links flex gap-4">
            {/* Logout Link */}
            <div className="mt-4">
              <button
                onClick={() => {
                  localStorage.removeItem("fashion_gallery_user");
                  window.location.reload();
                }}
                className="text-sm text-gray-500 hover:text-black underline focus:outline-none"
              >
                Log out
              </button>
            </div>

            <button
              onClick={() => setShowRequestModal(true)}
              className="mt-4 text-sm text-gray-500 hover:text-gray-900 block"
            >
              Submit a request
            </button>
          </div>
        </div>
        {/* Instagram */}
        <div className="w-full md:w-1/3 flex justify-start md:justify-end items-center mt-8 md:mt-0">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:text-gray-300 text-lg font-medium"
          >
            @titledworks
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
